/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { MonoMapStringObject } from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class CheckController<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags check-controller
   * @name CheckUsingGet
   * @summary check
   * @request GET:/dsp-admin/check
   * @secure
   */
  checkUsingGet = (params: RequestParams = {}) =>
    this.request<MonoMapStringObject, void>({
      path: `/dsp-admin/check`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags check-controller
   * @name HealthUsingGet
   * @summary health
   * @request GET:/dsp-admin/health
   * @secure
   */
  healthUsingGet = (params: RequestParams = {}) =>
    this.request<MonoMapStringObject, void>({
      path: `/dsp-admin/health`,
      method: "GET",
      secure: true,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new CheckController();
